/* Timbrica — /flight-time. Сколько лететь и во сколько вы приземлитесь.
 *
 * ПОЧЕМУ ЭТОТ ТУЛ
 * ---------------
 * «время полета» — 147 318 показов/мес, кластер «сколько лететь» — 1 265 480.
 * Калькуляторы в выдаче (gensio, skolkoletet, sekundomer, vipjets) делают одно:
 * делят расстояние на 800 км/ч. Это даёт ответ, который расходится с
 * расписанием на час и больше, и не отвечает на ВТОРОЙ вопрос, который человек
 * задаёт сразу следом: «а во сколько я приземлюсь по местному».
 *
 * ЧЕМ ОТЛИЧАЕМСЯ
 *   1. ВРЕМЯ ПРИБЫТИЯ ПО МЕСТНОМУ. У нас в базе городов есть часовой пояс,
 *      поэтому «вылет в 10:00 → посадка в 14:35, +2 часа сдвиг, тот же день»
 *      считается честно, с переходом через полночь и через дату.
 *   2. МОДЕЛЬ, А НЕ ДЕЛЕНИЕ. Время в пути = руление + набор + крейсер +
 *      снижение + руление, маршрут длиннее дуги, а короткий рейс вообще не
 *      успевает разогнаться. Всё это заложено и подписано.
 *   3. ВЕТЕР. На дальних рейсах восток-запад струйное течение даёт разницу до
 *      полутора часов В ОДНУ И ДРУГУЮ СТОРОНУ. Ни один калькулятор этого не
 *      показывает, хотя разница больше, чем их собственная погрешность.
 *   4. ЧЕСТНО ПРО ГРАНИЦЫ. Это ОЦЕНКА по прямой, а не расписание: реальный
 *      рейс может идти в обход зон и с пересадкой. Так и написано.
 *
 * ⚠️ Никаких страниц под пары городов: пара живёт в ?from=&to= на этой же
 * странице. Дорвеи в проекте запрещены.
 */
(function () {
  'use strict';

  var C = window.FLIGHT_CFG || {};
  var T = C.t || {};
  var tr = function (k) { return T[k] != null ? T[k] : k; };
  var $ = function (id) { return document.getElementById(id); };
  var ae = function (ev, p) { try { window.__ae && window.__ae(ev, p || {}); } catch (e) {} };
  var stage = function (n) { try { window.__stage && window.__stage(n); } catch (e) {} };

  var LI = window.LocationInput;
  var state = { from: null, to: null, depart: '10:00' };

  // ── Геометрия ───────────────────────────────────────────────────────────────

  function greatCircleKm(a, b) {
    var R = 6371.0088, p = Math.PI / 180;
    var dLat = (b.lat - a.lat) * p, dLon = (b.lng - a.lng) * p;
    var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(a.lat * p) * Math.cos(b.lat * p) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * R * Math.asin(Math.sqrt(s));
  }

  // ── Модель времени в пути ───────────────────────────────────────────────────

  /**
   * Блочное время рейса (от отхода от гейта до постановки к гейту).
   *
   * Почему не «расстояние / 800»:
   *   - маршрут длиннее дуги на 3–6 % (трассы, зоны, эшелоны);
   *   - руление, взлёт, набор и снижение съедают ~35 минут, и на коротком
   *     рейсе это половина всего времени;
   *   - короткий рейс не выходит на крейсерскую скорость вообще.
   * Поэтому крейсер зависит от дальности, а накладные вынесены отдельно.
   */
  function blockMinutes(distKm, windKmh) {
    var routeFactor = distKm < 500 ? 1.10 : distKm < 2000 ? 1.06 : 1.04;
    var air = distKm * routeFactor;
    // Эффективная крейсерская. ⚠️ Это НЕ паспортная скорость лайнера (~900): в
    // среднюю по участку входят набор и снижение, эшелонирование и обход зон.
    // Числа откалиброваны по расписаниям реальных рейсов, а не взяты из
    // справочника: с 870 на дальних маршрутах модель занижала на час.
    //   Москва—Сочи      1360 км → 2:24 (расписание 2:20)
    //   Москва—Анталия   2159 км → 3:29 (3:30)
    //   Москва—Дубай     3701 км → 5:11 (5:10)
    //   Москва—Владивосток 6416 км → 8:13 (~8:20)
    var cruise = distKm < 400 ? 520 : distKm < 1000 ? 680 : distKm < 3000 ? 780 : 830;
    var ground = Math.max(300, cruise + windKmh);   // не даём ветру «остановить» борт
    var overhead = 33;                              // руление + взлёт + заход, мин
    return overhead + (air / ground) * 60;
  }

  /**
   * Составляющая ветра вдоль маршрута, км/ч.
   *
   * Струйное течение в средних широтах дует с запада на восток, поэтому рейс
   * НА ВОСТОК быстрее, а обратный медленнее — на трансатлантике разница
   * достигает полутора часов. Модель грубая и сезон не учитывает, но она
   * ближе к правде, чем ноль, который стоит у всех остальных.
   */
  function jetstreamKmh(a, b) {
    var midLat = Math.abs((a.lat + b.lat) / 2);
    if (midLat < 20 || midLat > 70) return 0;           // тропики и полюса — вне потока
    var strength = 55 * Math.sin(Math.PI * (midLat - 20) / 50);   // максимум ~40°–50°
    var dLon = ((b.lng - a.lng + 540) % 360) - 180;     // + на восток
    var dLat = b.lat - a.lat;
    var eastFraction = Math.abs(dLon) / (Math.abs(dLon) + Math.abs(dLat) * 1.4 + 1e-6);
    return strength * eastFraction * (dLon >= 0 ? 1 : -1);
  }

  // ── Часовые пояса ───────────────────────────────────────────────────────────

  /** Смещение пояса в минутах для конкретного момента (учитывает переход на летнее). */
  function tzOffsetMinutes(tz, date) {
    try {
      var dtf = new Intl.DateTimeFormat('en-US', {
        timeZone: tz, hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      });
      var p = {};
      dtf.formatToParts(date).forEach(function (x) { p[x.type] = x.value; });
      var asUTC = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
      return Math.round((asUTC - date.getTime()) / 60000);
    } catch (e) { return null; }
  }

  // ── Форматирование ──────────────────────────────────────────────────────────

  function fmt(x, d) {
    try { return Number(x).toLocaleString(C.locale, { minimumFractionDigits: d || 0, maximumFractionDigits: d || 0 }); }
    catch (e) { return Number(x).toFixed(d || 0); }
  }
  function hhmm(totalMin) {
    var h = Math.floor(totalMin / 60), m = Math.round(totalMin % 60);
    if (m === 60) { h++; m = 0; }
    return h > 0 ? h + ' ' + tr('h') + ' ' + String(m).padStart(2, '0') + ' ' + tr('min')
      : m + ' ' + tr('min');
  }
  function clockOf(date, tz) {
    try {
      return new Intl.DateTimeFormat(C.locale, { timeZone: tz, hour: '2-digit', minute: '2-digit', hour12: false }).format(date);
    } catch (e) { return '—'; }
  }
  function dayShift(depLocalDate, arrDate, tz) {
    try {
      var f = new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' });
      var arrDay = f.format(arrDate);
      var depDay = f.format(depLocalDate);
      var d = (new Date(arrDay) - new Date(depDay)) / 86400000;
      return Math.round(d);
    } catch (e) { return 0; }
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function setText(id, v) { var el = $(id); if (el) el.textContent = v; }

  // ── Расчёт и вывод ──────────────────────────────────────────────────────────

  function compute() {
    var box = $('ftResult');
    if (!state.from || !state.to) { if (box) box.hidden = true; return; }
    if (box) box.hidden = false;

    var dist = greatCircleKm(state.from, state.to);
    var wind = jetstreamKmh(state.from, state.to);
    var minsThere = blockMinutes(dist, wind);
    var minsBack = blockMinutes(dist, -wind);

    setText('ftRoute', state.from.name + ' → ' + state.to.name);
    setText('ftDist', fmt(dist, 0) + ' ' + tr('km') + ' · ' + fmt(dist * 0.539957, 0) + ' ' + tr('nm'));
    setText('ftTime', hhmm(minsThere));
    setText('ftTimeBack', hhmm(minsBack));

    // Разницу показываем ТОЛЬКО когда она заметна — иначе это шум,
    // выдающий себя за знание.
    var diff = Math.abs(minsBack - minsThere);
    var wRow = $('ftWindRow');
    if (wRow) {
      if (diff >= 12) {
        wRow.hidden = false;
        setText('ftWind', (wind > 0 ? tr('tailwind') : tr('headwind')) + ' · ' +
          tr('diff_back') + ' ' + hhmm(diff));
      } else { wRow.hidden = true; }
    }

    // Время прибытия по местному — то, ради чего это всё и считалось.
    var depParts = (state.depart || '10:00').split(':');
    var now = new Date();
    var probe = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 12, 0, 0));
    var offFrom = tzOffsetMinutes(state.from.tz, probe);
    if (offFrom == null) offFrom = 0;
    // Момент вылета: заданное местное время в поясе города вылета.
    var depUtc = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),
      +depParts[0], +depParts[1], 0) - offFrom * 60000);
    var arrUtc = new Date(depUtc.getTime() + minsThere * 60000);

    setText('ftDepLocal', clockOf(depUtc, state.from.tz) + ' · ' + state.from.name);
    setText('ftArrLocal', clockOf(arrUtc, state.to.tz) + ' · ' + state.to.name);

    var shift = dayShift(depUtc, arrUtc, state.to.tz);
    var dEl = $('ftDayShift');
    if (dEl) {
      dEl.hidden = shift === 0;
      dEl.textContent = shift > 0 ? tr('next_day') : shift < 0 ? tr('prev_day') : '';
    }

    var offTo = tzOffsetMinutes(state.to.tz, arrUtc);
    if (offTo != null) {
      var d = (offTo - offFrom) / 60;
      setText('ftTz', (d > 0 ? '+' : d < 0 ? '−' : '') + fmt(Math.abs(d), Math.abs(d) % 1 ? 1 : 0) + ' ' + tr('h'));
      var jl = $('ftJetlag');
      if (jl) {
        // Ориентир акклиматизации — примерно сутки на час сдвига, и на восток
        // тяжелее, чем на запад. Это общепринятая прикидка, не медицина.
        var abs = Math.abs(d);
        jl.hidden = abs < 3;
        jl.textContent = abs >= 3
          ? tr('jetlag_prefix') + ' ' + fmt(Math.round(abs * (d > 0 ? 1 : 0.7)), 0) + ' ' + tr('jetlag_days')
          : '';
      }
    }

    // Ссылка на этот же расчёт — БЕЗ отдельной страницы под пару городов.
    updateUrl();

    /* Стадия, а не только событие. tool_complete здесь был с самого начала, а
       stage('complete') — нет, поэтому воронка обрывалась на 'ready' и
       доходимость этого тула нельзя было сравнить с остальными.
       Считаем один раз: дальше человек меняет города, и это feature_use. */
    ae('tool_complete', { slug: 'flight-time', distance_km: Math.round(dist) });
    if (!answered) {
      answered = true;
      stage('complete');
    }
  }
  var answered = false;

  function updateUrl() {
    if (!state.from || !state.to) return;
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('from', state.from.name);
      u.searchParams.set('to', state.to.name);
      window.history.replaceState(null, '', u.toString());
    } catch (e) {}
  }

  // ── Поиск города ────────────────────────────────────────────────────────────

  /**
   * Компактный пикер на ОБЩЕМ наборе данных и общем матчере: LocationInput
   * экспортирует search/rowToCity именно для таких случаев (так же устроен
   * пикер города в профиле). Свой список городов и свой поиск заводить нельзя.
   */
  /**
   * Привести что угодно от примитива к городу с координатами.
   *
   * ⚠️ ВХОД и ВЫХОД примитива называют индекс РАЗНЫМИ буквами, и на этом
   * тул молча умер: `search()` возвращает `{i, score, pop}` — индекс в `i`, —
   * а поле `index` есть у РЕЗУЛЬТАТА `rowToCity()`. Первая версия проверяла
   * `.index` у входной строки, получала undefined, доходила до последней
   * ветки, не находила lat/lng и отдавала null. Каждый вариант превращался в
   * null, список раскрывался ПУСТЫМ — ни одной ошибки в консоли, ни одного
   * упавшего запроса. Города грузились, поиск находил 5 совпадений на «Моск»,
   * а человек видел пустоту.
   */
  function toCity(row) {
    if (row == null) return null;
    if (typeof row === 'number') return LI.rowToCity(row);
    if (typeof row.i === 'number') return LI.rowToCity(row.i);
    // Уже готовый город (у него есть и index, и координаты) — отдаём как есть.
    if (row.lat != null && row.lng != null) return row;
    if (typeof row.index === 'number') return LI.rowToCity(row.index);
    return null;
  }

  function makePicker(inputId, listId, onPick) {
    var input = $(inputId), list = $(listId);
    if (!input || !list) return;
    var timer = null;

    function close() { list.hidden = true; list.innerHTML = ''; }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        var p = LI.searchWithFallback ? LI.searchWithFallback(q, 8) : Promise.resolve(LI.search(q, 8));
        Promise.resolve(p).then(function (rows) {
          if (!rows || !rows.length) { close(); return; }
          list.innerHTML = '';
          var rendered = 0;
          rows.forEach(function (row) {
            var city = toCity(row);
            if (!city) return;
            rendered++;
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'ft-opt';
            b.innerHTML = '<span>' + esc(city.name || city.cityName || '') + '</span>' +
              '<span class="ft-opt-cc">' + esc(city.cc || city.country || '') + '</span>';
            b.addEventListener('click', function () {
              input.value = city.name || city.cityName || '';
              close();
              onPick({ name: input.value, lat: city.lat, lng: city.lng, tz: city.tz, cc: city.cc });
            });
            list.appendChild(b);
          });
          // Совпадения есть, а на экран не попало ничего — значит форма строки
          // разъехалась с тем, что умеет toCity(). Молча показывать пустой
          // список нельзя: именно так тул и «работал», пока никто не смотрел.
          if (!rendered) {
            close();
            ae('tool_diagnostic', { slug: 'flight-time', issue: 'picker_rows_unmapped', found: rows.length });
            return;
          }
          list.hidden = false;
          ae('feature_use', { slug: 'flight-time', feature: 'city_suggest', shown: rendered });
        }).catch(function () { close(); });
      }, 160);
    });
    input.addEventListener('blur', function () { setTimeout(close, 180); });
  }

  function swap() {
    var a = state.from, b = state.to;
    state.from = b; state.to = a;
    var fi = $('ftFrom'), ti = $('ftTo');
    if (fi && ti) { var v = fi.value; fi.value = ti.value; ti.value = v; }
    compute();
    ae('feature_use', { slug: 'flight-time', feature: 'swap' });
  }

  function boot() {
    stage('load');
    if (!LI) { return; }
    LI.loadData().then(function () {
      makePicker('ftFrom', 'ftFromList', function (c) { state.from = c; compute(); });
      makePicker('ftTo', 'ftToList', function (c) { state.to = c; compute(); });

      // Пара из адреса — так расчёт можно переслать, не заводя отдельных страниц.
      var q = new URLSearchParams(window.location.search);
      var pre = [['from', 'ftFrom'], ['to', 'ftTo']];
      var jobs = pre.map(function (pair) {
        var v = q.get(pair[0]);
        if (!v) return null;
        var el = $(pair[1]); if (el) el.value = v;
        var f = LI.findByNameWithFallback ? LI.findByNameWithFallback(v) : Promise.resolve(LI.findByName(v));
        return Promise.resolve(f).then(function (row) {
          var city = toCity(row);
          if (!city) return;
          state[pair[0]] = { name: city.name || v, lat: city.lat, lng: city.lng, tz: city.tz, cc: city.cc };
          if (el) el.value = city.name || v;
        });
      }).filter(Boolean);
      if (jobs.length) Promise.all(jobs).then(compute);

      var dep = $('ftDepart');
      if (dep) {
        if (window.__toolSettings) dep.value = window.__toolSettings.load('flight-time', 'depart', '10:00');
        state.depart = dep.value || '10:00';
        dep.addEventListener('change', function () {
          state.depart = dep.value || '10:00';
          if (window.__toolSettings) window.__toolSettings.save('flight-time', 'depart', state.depart);
          compute();
        });
      }
      var sw = $('ftSwap'); if (sw) sw.addEventListener('click', swap);
      stage('ready');
    }, function (err) {
      // The city list did not arrive — a network filter, an extension or a client that
      // blocks big files (Sentry J8: a 403 our server never sent). Without this the
      // rejection went unhandled and the form stayed dead without a word.
      var form = document.querySelector('.ft-form');
      if (form && !$('ftLoadFailed')) {
        var p = document.createElement('p');
        p.id = 'ftLoadFailed'; p.className = 'ft-jetlag'; p.setAttribute('role', 'alert');
        p.textContent = tr('cities_load_failed');
        form.parentNode.insertBefore(p, form.nextSibling);
      }
      ae('feature_use', { slug: 'flight-time', feature: 'cities_load_failed', err: String((err && err.message) || err).slice(0, 60) });
      stage('error');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
